import { FunctionComponent } from 'react';
import { MenuItem, Select } from '@mui/material';
import { TopNValue } from '../../../../shared/utils/analytics-utils';

/**
 * Compact "Top N" dropdown for chart headers: Top 5 / Top 10 / Top 20 / All.
 * Controls how many real items show before the rest collapse into "Other"
 * (All = no "Other").
 */
export const TopNSelect: FunctionComponent<{
  value: TopNValue;
  onChange: (value: TopNValue) => void;
}> = ({ value, onChange }) => (
  <Select
    size='small'
    value={String(value)}
    onChange={(e) => {
      const next = e.target.value;
      onChange(next === 'all' ? 'all' : Number(next));
    }}
    sx={{
      height: 32,
      '& .MuiSelect-select': { py: 0.25, pl: 1.25, fontSize: '0.8rem' },
    }}
  >
    <MenuItem value='5'>Top 5</MenuItem>
    <MenuItem value='10'>Top 10</MenuItem>
    <MenuItem value='20'>Top 20</MenuItem>
    <MenuItem value='all'>All</MenuItem>
  </Select>
);
